import { Prepack } from 'graphql-api/gql-api-interfaces';

import { DeliveryItems, ProductPrepackEntities } from '../../../models';
import { countPrepackItems } from '../../shared/count-prepack-items';

const sumReducer = (sum: number, quantity: number) => sum + quantity;

// This function receives total quantity as a count of sizes and prepacks
// The output of this function is a total quantity of sizes and total quantity of prepack items
// Example:
// total = 2 (1 size + 1 prepack)
// result = 61 (1 size + 60 sizes of prepack)
export const calculatePrepacks = (
  total: number,
  nowDeliveryItems: DeliveryItems,
  prepacks: ProductPrepackEntities,
): number => {
  const prepackIds = Object.keys(prepacks);
  const orderedPrepackIds = Object.keys(
    nowDeliveryItems.items,
  ).filter((productId) => prepackIds.includes(productId));
  const countPrepacks = orderedPrepackIds
    .map((prepackId) => nowDeliveryItems.items[prepackId].quantity)
    .reduce(sumReducer, 0);
  // typecast below is sure that we can access the prepacks entity because we search for it in keys above
  const countPrepackItemsTotal = orderedPrepackIds
    .map((prepackId) =>
      countPrepackItems(
        prepacks[prepackId] as Partial<Prepack>,
        nowDeliveryItems.items[prepackId].quantity,
      ),
    )
    .reduce(sumReducer, 0);
  return total - countPrepacks + countPrepackItemsTotal;
};
